import React from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

/** Right rail: referral request summary + optional prepare-draft CTA. */
export default function LetterRequestSidebar({
  row, canEdit, primary, busy, setBusy, ensureDraft, signatureSrc, issued,
}) {
  return (
    <aside className="h-fit space-y-4">
      <div className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm">
        <h3 className="font-heading text-lg text-[#071B34]">Request</h3>
        <dl className="mt-3 space-y-2 text-sm">
          <Row label="Patient" value={row.patient?.name} />
          <Row label="Hospital" value={row.seeking?.hospital_clinic} />
          <Row label="Speciality" value={row.seeking?.specialisation} />
          <Row label="Station" value={row.station_type === 'out_station' ? 'Out-station' : 'In-station'} />
          <Row label="Credit letter" value={row.needs_credit_letter ? 'Requested' : 'Not required'} />
          <Row label="Reason" value={row.seeking?.reason} />
        </dl>
        {!row.letter?.sections && canEdit && (
          <Button
            className="mt-4 w-full text-white"
            style={{ background: primary }}
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try {
                await ensureDraft();
                toast.success('Draft prepared');
              } catch (e) {
                toast.error(e?.response?.data?.detail || 'Failed');
              } finally {
                setBusy(false);
              }
            }}
          >
            Prepare letter draft
          </Button>
        )}
      </div>
      {signatureSrc ? (
        <div className="rounded-xl border border-stone-200 bg-white p-4 shadow-sm">
          <p className="text-xs uppercase tracking-wide text-stone-400">
            {issued ? 'Signature on letter' : 'Signature on file'}
          </p>
          <img src={signatureSrc} alt="Signature" className="mt-2 max-h-16" />
        </div>
      ) : null}
    </aside>
  );
}

function Row({ label, value }) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-wide text-stone-400">{label}</dt>
      <dd className="font-medium text-stone-800">{value || '—'}</dd>
    </div>
  );
}
